import React, { useState } from 'react';
import { Alert, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import ReviewHistoryList from './notesAndAssumptionReviews/ReviewHistoryList';
import ReviewerActionForm from './notesAndAssumptionReviews/ReviewerActionForm';
import ConsultantResponseForm from './notesAndAssumptionReviews/ConsultantResponseForm';
import ReviewStatusMessage from './notesAndAssumptionReviews/ReviewStatusMessage';
import { REVIEW_STATUS } from '@rd-web-markets/market/dist/constants';
import { sortByDateCreated } from '@rd-web-markets/shared/dist/util/date/dateUtils';
const NotesAndAssumptionReviewSection = _ref => {
  let {
    note,
    onReviewUpdate,
    loading,
    claimId
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [reviewerComments, setReviewerComments] = useState('');
  const [consultantResponse, setConsultantResponse] = useState('');
  const hasActiveReview = note.has_active_cost_review;
  if (!hasActiveReview) {
    return null;
  }
  const currentReview = note.current_review;
  const hasBeenReviewed = note.has_been_reviewed;
  if (!currentReview) {
    return null;
  }
  const reviewWithChangeSet = note.active_reviews?.find(r => r.id === currentReview.id);
  const changeSet = reviewWithChangeSet?.change_set;
  const isReviewer = changeSet && user.id === changeSet.assigned_to_id;
  const isConsultant = changeSet && user.id === changeSet.author_id;
  const reviewHistory = note.active_reviews?.sort(sortByDateCreated)?.reverse() || [];
  const handleInitialAndClose = async () => {
    if (window.confirm('Are you sure')) {
      await onReviewUpdate({
        noteId: note.id,
        reviewId: currentReview.id,
        data: {
          status: 'closed',
          reviewer_comments: reviewerComments,
          reviewer_id: user.id
        }
      });
      setReviewerComments('');
    }
  };
  const handleRequireClarification = async () => {
    if (!reviewerComments.trim()) {
      alert('Please enter comments');
      return;
    }
    if (window.confirm('Are you sure')) {
      await onReviewUpdate({
        noteId: note.id,
        reviewId: currentReview.id,
        data: {
          status: 'clarification_required',
          reviewer_comments: reviewerComments,
          reviewer_id: user.id
        }
      });
      setReviewerComments('');
    }
  };
  const handleConsultantRespond = async () => {
    if (!consultantResponse.trim()) {
      alert('Please enter response');
      return;
    }
    await onReviewUpdate({
      noteId: note.id,
      reviewId: currentReview.id,
      data: {
        consultant_response: consultantResponse
      }
    });
    setConsultantResponse('');
  };
  if (hasBeenReviewed) {
    return /*#__PURE__*/React.createElement(Card, {
      className: "mt-2 border-start border-secondary border-3"
    }, /*#__PURE__*/React.createElement(Card.Body, {
      className: "bg-light"
    }, /*#__PURE__*/React.createElement(Alert, {
      variant: "info",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement("strong", null, "Previously Reviewed:"), " This note was reviewed in a previous review cycle and cannot be reviewed again."), /*#__PURE__*/React.createElement(ReviewHistoryList, {
      reviewHistory: reviewHistory
    })));
  }
  return /*#__PURE__*/React.createElement(Card, {
    className: "mt-2 border-start border-primary border-3"
  }, /*#__PURE__*/React.createElement(Card.Body, {
    className: "bg-light"
  }, /*#__PURE__*/React.createElement(ReviewHistoryList, {
    reviewHistory: reviewHistory
  }), currentReview.status === REVIEW_STATUS.PENDING && isReviewer && /*#__PURE__*/React.createElement(ReviewerActionForm, {
    reviewerComments: reviewerComments,
    setReviewerComments: setReviewerComments,
    onInitialAndClose: handleInitialAndClose,
    onRequireClarification: handleRequireClarification,
    loading: loading
  }), currentReview.status === REVIEW_STATUS.CLARIFICATION_REQUIRED && isConsultant && /*#__PURE__*/React.createElement(ConsultantResponseForm, {
    consultantResponse: consultantResponse,
    setConsultantResponse: setConsultantResponse,
    onRespond: handleConsultantRespond,
    loading: loading
  }), /*#__PURE__*/React.createElement(ReviewStatusMessage, {
    status: currentReview.status,
    isReviewer: isReviewer,
    isConsultant: isConsultant
  })));
};
export default NotesAndAssumptionReviewSection;